interface HighlightTextProps {
	text: string;
	highlights: string[];
	className?: string;
	highlightClassName?: string;
}

export default function HighlightText({
	text,
	highlights,
	className,
	highlightClassName = "font-bold text-primary-blue-dark",
}: HighlightTextProps) {
	if (!highlights.length) {
		return <p className={className}>{text}</p>;
	}

	const escapedWords = highlights.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
	const regex = new RegExp(`(${escapedWords.join("|")})`, "gi");
	const parts = text.split(regex);

	return (
		<p className={className}>
			{parts.map((part, index) =>
				highlights.some((word) => word.toLowerCase() === part.toLowerCase()) ? (
					<strong key={index} className={highlightClassName}>
						{part}
					</strong>
				) : (
					part
				)
			)}
		</p>
	);
}
